import { useQuery } from '@tanstack/react-query';
import { getData, transformToOption } from '../../utils/functional/fp';
import { useAPIErrorHandler } from './useAPIErrorHandler';

import { getProductLines } from '../../api';

const useGetProductLines = () => {
  const handleAPIError = useAPIErrorHandler();

  return useQuery({
    queryKey: ['product-lines'],
    queryFn: () => getProductLines().then(getData),
    select: ({ productLines }) =>
      productLines.map(
        transformToOption(
          (data) => data.name,

          (data) => data.key
        )
      ),
    onError: handleAPIError('Unable to retrieve product lines.'),
    cacheTime: Infinity,
    staleTime: 60 * 60 * 1000, // 1 hour stale time
  });
};

export default useGetProductLines;
